import { DTYPES } from "./constants";

const SOURCE_ID = "units";
const LAYER_ID = "units";
const BORDER_HIGHLIGHT_LAYER_ID = "units_border_highlight";
const FILTER_LAYER_IDS = [LAYER_ID];
const CLICKABLE_LAYERS = [LAYER_ID];
const UNIQUE_COLUMN = "id";

const API_BASE_ENDPOINT = "units";
const TILE_ENDPOINT = `${
  process.env.REACT_APP_SERVER_URL
}/api/${API_BASE_ENDPOINT}/tiles/{z}/{x}/{y}.pbf?access_token=${localStorage.getItem(
  "authToken"
)}`;

const INITIAL_FILTER_STATE = {
  id: {
    column: "id",
    label: "ID",
    dtype: DTYPES.INTEGER,
    value: [],
    excludeSelected: false,
    excludeNullValues: false,
  },
  county: {
    column: "county",
    label: "County",
    dtype: DTYPES.STRING,
    value: [],
    excludeSelected: false,
    excludeNullValues: false,
  },
  name: {
    column: "name",
    label: "Name",
    dtype: DTYPES.STRING,
    value: [],
    excludeSelected: false,
    excludeNullValues: false,
  },
  rrc_id: {
    column: "rrc_id",
    label: "RRC ID",
    dtype: DTYPES.STRING,
    value: [],
    excludeSelected: false,
    excludeNullValues: false,
  },
  operator: {
    column: "operator",
    label: "Operator",
    dtype: DTYPES.STRING,
    value: [],
    excludeSelected: false,
    excludeNullValues: false,
  },
  review_status: {
    column: "review_status",
    label: "Review Status",
    dtype: DTYPES.STRING,
    value: [],
    excludeSelected: false,
    excludeNullValues: false,
  },
  "last_offer.created_at": {
    column: "last_offer.created_at",
    label: "Last Offer Date",
    dtype: DTYPES.DATE,
    value: {},
    excludeSelected: false,
    excludeNullValues: false,
  },
};

const EXPORT_COLUMNS = [
  { key: "id", label: "ID" },
  { key: "name", label: "Name" },
  { key: "name_formatted", label: "Name Formatted" },
  { key: "rrc_id", label: "RRC ID" },
  { key: "county", label: "County" },
  { key: "operator", label: "Operator" },
  { key: "acres", label: "Acres" },
  { key: "review_status", label: "Review Status" },
  { key: "offer_count", label: "Offer Count" },
  {
    key: "last_offer_at",
    label: "Last Offer Date",
    type: "date",
    format: "YYYY-MM-DD",
  },
];

const STYLES = {
  "fill-outline-color": "#000000",
  "fill-color": "#FE00FE",
  "fill-opacity": 0.3,
};

const BORDER_HIGHLIGHT_STYLES = {
  "line-color": "#000",
  "line-width": 3,
};

const ADD_BEFORE = "Laterals";

const addSource = (mapRef) => {
  if (!mapRef.current.getSource(SOURCE_ID)) {
    mapRef.current.addSource(SOURCE_ID, {
      type: "vector",
      tiles: [
        `${
          process.env.REACT_APP_SERVER_URL
        }/api/${API_BASE_ENDPOINT}/tiles/{z}/{x}/{y}.pbf?access_token=${localStorage.getItem(
          "authToken"
        )}`,
      ],
      minzoom: 0,
      maxzoom: 14,
    });
  }
};

const addLayers = (mapRef) => {
  if (!mapRef.current.getLayer(LAYER_ID)) {
    mapRef.current.addLayer(
      {
        id: LAYER_ID,
        type: "fill",
        source: SOURCE_ID,
        "source-layer": SOURCE_ID,
        layout: {
          visibility: "none",
        },
        paint: STYLES,
      },
      ADD_BEFORE
    );
  }

  if (!mapRef.current.getLayer(BORDER_HIGHLIGHT_LAYER_ID)) {
    mapRef.current.addLayer(
      {
        id: BORDER_HIGHLIGHT_LAYER_ID,
        type: "line",
        source: SOURCE_ID,
        "source-layer": SOURCE_ID,
        layout: {},
        paint: BORDER_HIGHLIGHT_STYLES,
        filter: ["in", UNIQUE_COLUMN, ""],
      }
      // ADD_BEFORE
    );
  }
};

const addAll = (mapRef) => {
  addSource(mapRef);
  addLayers(mapRef);
};

export {
  EXPORT_COLUMNS,
  SOURCE_ID,
  LAYER_ID,
  FILTER_LAYER_IDS,
  BORDER_HIGHLIGHT_LAYER_ID,
  CLICKABLE_LAYERS,
  UNIQUE_COLUMN,
  STYLES,
  BORDER_HIGHLIGHT_STYLES,
  API_BASE_ENDPOINT,
  TILE_ENDPOINT,
  INITIAL_FILTER_STATE,
  addAll,
};
